@import "../config/_helpers";
.reviews-section {
	overflow: hidden;
	margin: 10px 0 !important;
}
